import React from 'react';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '../../ui/alert-dialog';
import { useLang, tx } from '../../../i18n/LanguageContext';

export const ConfirmDialog = ({ open, title, desc, onConfirm, onCancel }) => {
  const { lang, isRTL } = useLang();
  const L = (ar, en) => tx(lang, ar, en);
  return (
    <AlertDialog open={open} onOpenChange={(v) => !v && onCancel()}>
      <AlertDialogContent dir={isRTL ? 'rtl' : 'ltr'} data-testid="content-confirm-dialog" className="max-w-md">
        <AlertDialogHeader className="text-start sm:text-start">
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{desc}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="gap-2 sm:gap-2">
          <AlertDialogCancel data-testid="content-confirm-cancel" className="mt-0">{L('إلغاء', 'Cancel')}</AlertDialogCancel>
          <AlertDialogAction data-testid="content-confirm-ok" onClick={onConfirm} className="bg-rose-600 hover:bg-rose-700">{L('حذف', 'Delete')}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
